export default {
  logger: {
    api: true,
    events: true,
    websocket: true,
    model: true,
    component: true,
    debug: true,
    warn: false
  }
};
